import React, { useMemo } from 'react';
import { useQuery } from 'react-query';
import { companyAdminKeys } from './query-keys';
import CompanyAPI from 'api/CompanyAPI';
import { AxiosResponse } from 'axios';

function useMongoAuthTokenQuery() {
  const { data: tokenRes, ...rest } = useQuery<
    AxiosResponse<{
      successResponse: string;
    }>,
    Error
  >({
    queryKey: companyAdminKeys.getMongoAuthToken(),
    queryFn: () => CompanyAPI.getMongoAuthToken(),
    staleTime: 15 * 60 * 1000,
    keepPreviousData: true,
  });
  const authToken = useMemo(() => tokenRes?.data.successResponse || '', [tokenRes]);

  return {
    authToken,
    ...rest,
  };
}

export default useMongoAuthTokenQuery;
